import React from "react";
import styled from "styled-components";

const Indicator = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  margin: 0 20px;
  color: #f5f7fa; /* Brighter text for better visibility */
  font-family: "Poppins", "Segoe UI", sans-serif; /* More modern font */
  font-weight: 500; /* Medium weight for better readability */
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.3); /* Subtle glow effect */
`;

const StatusDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => (props.isOnline ? "#4caf50" : "#7f8c8d")};
  margin-right: 8px;
  position: relative;

  ${(props) =>
    props.isOnline &&
    `
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: rgba(76, 175, 80, 0.4);
      animation: pulse 1.5s infinite;
    }
    
    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 0.8;
      }
      50% {
        transform: scale(1.5);
        opacity: 0.2;
      }
      100% {
        transform: scale(1);
        opacity: 0.8;
      }
    }
  `}
`;

const OnlineStatusIndicator = ({ isOnline, className }) => {
  return (
    <Indicator className={className}>
      <StatusDot isOnline={isOnline} />
      <span>{isOnline ? "Online" : "Offline"}</span>
    </Indicator>
  );
};

export default OnlineStatusIndicator;
